import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {User, UserService, UUID} from '@nh/angular-tses';
import {take} from 'rxjs/operators';

@Component({
  selector: 'das-user-display',
  templateUrl: './user-display.component.html',
  styleUrls: ['./user-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserDisplayComponent {
  @Output() public name: EventEmitter<string> = new EventEmitter();

  @Input()
  public set userId(userId: UUID | string) {
    userId = userId instanceof UUID ? userId : UUID.orNull(userId);

    if (userId) {
      this.userService
        .getUserFromId(userId)
        .pipe(take(1))
        .subscribe(user => {
          this.user = user;
          this.name.emit(user.name);
          this.cdr.markForCheck();
        });
    } else {
      this.user = null;
      this.name.emit(null);
      this.cdr.markForCheck();
    }
  }

  public user: User;

  constructor(private userService: UserService, private cdr: ChangeDetectorRef) {}
}
